<template>
  <div class="terms">
    <h1>Termos de Uso e Política de Privacidade da Plataforma Ganhe Mais</h1>
    <h2>1. Introdução</h2>
    <p>
      Bem-vindo à plataforma Ganhe Mais! Ao acessar www.ganhemais.com.br, você
      concorda em cumprir estes termos de uso e nossa política de privacidade.
      Estes documentos regem seu acesso e uso da plataforma, que oferece cursos
      gratuitos em artesanato, empreendedorismo e inovação.
    </p>
    <h2>2. Cadastro</h2>
    Para acessar os cursos, é necessário um cadastro simples. Ao se cadastrar,
    você concorda em fornecer informações verdadeiras e atualizá-las conforme
    necessário. Os dados solicitados são:
    <ol>
      <li>a) Nome</li>
      <li>b) Data de nascimento</li>
      <li>c) CPF (obrigatório)</li>
      <li>d) Email (obrigatório)</li>
      <li>e) Endereço</li>
      <li>f) Descrição pessoal (biografia)</li>
    </ol>

    <p>
      Os dados pessoais identificados acima como “obrigatórios” são tratados
      para identificação e autenticação de cadastro em sistemas eletrônicos, nos
      termos da letra “g” do inciso II do artigo 11 da Lei Geral de Proteção de
      Dados Pessoais – Lei 13.709/2018. Caso você forneça dados que não sejam
      obrigatórios, você automaticamente consente que o Grupo Lince trate tais
      dados, nos termos deste documento.
    </p>

    <h2>3. Uso da Plataforma</h2>
    <p>
      A plataforma é destinada ao aprendizado e ao desenvolvimento pessoal.
      Qualquer uso fora deste escopo é proibido, como por exemplo a
      redistribuição comercial do conteúdo.
    </p>

    <h2>4. Política de Privacidade</h2>
    <ul>
      <li>Coleta de Dados: informações básicas durante o cadastro.</li>
      <li>
        Uso de Dados: Utilizamos suas informações para personalizar sua
        experiência e comunicar novidades e oportunidades relacionadas à
        plataforma.
      </li>
      <li>
        Compartilhamento de Dados: Os dados pessoais relacionados neste
        documento não serão compartilhados, vendidos, ou de alguma forma
        transferidos a terceiros, exceto para cumprimento das obrigações legais
        e/ou regulatórias pela empresa, ou por ordem judicial.
      </li>
      Segurança dos Dados: Empregamos medidas de segurança para proteger suas
      informações contra acesso não autorizado, alteração, divulgação ou
      destruição.
    </ul>

    <h2>5. Cookies e Tecnologias Semelhantes</h2>
    <p>
      Utilizamos cookies para melhorar a experiência de navegação. Você pode
      controlar o uso de cookies através das configurações do seu navegador.<br /><br />
      O que são cookies?<br /><br />
      Como é prática comum em quase todos os sites profissionais, este site usa
      cookies, que são pequenos arquivos baixados no seu computador, para
      melhorar sua experiência. Esta página descreve quais informações eles
      coletam, como as usamos e por que às vezes precisamos armazenar esses
      cookies. Também compartilharemos como você pode impedir que esses cookies
      sejam armazenados, no entanto, isso pode prejudicar certos elementos da
      funcionalidade do site.<br /><br />
      Como usamos os cookies?<br /><br />
      Utilizamos cookies por vários motivos, detalhados abaixo. Infelizmente, na
      maioria dos casos, não existem opções padrão do setor para desativar os
      cookies sem desativar completamente a funcionalidade e os recursos que
      eles adicionam a este site. É recomendável que você deixe todos os cookies
      se não tiver certeza se precisa ou não deles, caso sejam usados para
      fornecer um serviço que você usa.<br /><br />
      Desativar cookies<br /><br />
      Você pode impedir a configuração de cookies ajustando as configurações do
      seu navegador (consulte a Ajuda do navegador para saber como fazer isso).
      Esteja ciente de que a desativação de cookies afetará a funcionalidade
      deste e de muitos outros sites que você visita. A desativação de cookies
      geralmente resultará na desativação de determinadas funcionalidades e
      recursos deste site. Portanto, é recomendável que você não desative os
      cookies.
    </p>

    <h2>6. Direitos de Propriedade Intelectual</h2>
    <p>
      Todo o conteúdo da plataforma, incluindo cursos, é propriedade da Ganhe
      Mais ou de seus licenciantes. É concedida a você uma licença limitada, não
      exclusiva e intransferível para acessar e utilizar o conteúdo para fins
      pessoais e não comerciais.
    </p>

    <h2>7. Modificações nos Termos</h2>
    <p>
      Podemos modificar estes termos e a política de privacidade a qualquer
      momento. Sua continuidade no uso da plataforma após tais mudanças
      constitui sua aceitação dos novos termos.
    </p>

    <h2>8. Contato</h2>
    <p>
      Em caso de dúvidas sobre estes termos ou a política de privacidade, entre
      em contato conosco através do e-mail
      <a href="mailto:sac.circulo@circulo.com.br">sac.circulo@circulo.com.br</a>
    </p>

    <h2>9. Lei Aplicável e Jurisdição</h2>
    <p>
      Estes termos serão regidos e interpretados de acordo com as leis do
      Brasil, e qualquer disputa relacionada a estes termos estará sujeita à
      jurisdição exclusiva dos tribunais do Brasil. Ao utilizar a plataforma
      Ganhe Mais, você concorda com estes termos de uso e política de
      privacidade.
    </p>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CirculoTerms"
});
</script>

<style scoped>
.terms {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  box-sizing: border-box;
}

h1 {
  text-align: center;
  margin-top: 2rem;
  font-size: 1.5rem;
}

h2 {
  margin-top: 2rem;
}

ul,
ol {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

a {
  text-decoration: underline;
  color: blue;
}

@media screen and (max-width: 550px) {
  h1 {
    font-size: 1.2rem;
  }
}
</style>
